import { render, staticRenderFns } from "./PageIndexActions.vue?vue&type=template&id=53bc568b&"
import script from "./PageIndexActions.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PageIndexActions.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports